<div class="row">
  <div class="col-12">
    <div class="card w-100">
      <div class="card-body d-flex flex-column">
        <div class="news-update-widget__header">
          <h5 class="news-update-widget__header__title">
            {{ 'pages.transport.tracking-overview.widgets.news-updates.title' | translate }}
          </h5>
        </div>

        @if (isLoading()) {
          <p-skeleton class="mb-2" />
          <p-skeleton width="10rem" class="mb-2" />
          <p-skeleton width="5rem" class="mb-2" />
          <p-skeleton height="2rem" class="mb-2" />
          <p-skeleton width="10rem" height="4rem" />
        }

        @if (isSuccess()) {
          <p-dataview
            [value]="data()"
            [paginator]="true"
            [showPageLinks]="true"
            [pageLinks]="3"
            [showFirstLastIcon]="false"
            [rows]="3"
            class="border-0 save-view__dataview"
            [alwaysShowPaginator]="false"
            paginatorStyleClass="p--0"
            (onPage)="onPaginatorChanged()"
          >
            <ng-template #list let-news>
              @for (newsItem of news; track $index) {
                <transport-news-item [newsItem]="newsItem" />
              }
            </ng-template>
          </p-dataview>
        }

        @if (isEmpty()) {
          <h6 class="news-update-widget__empty-state__title">
            {{ 'pages.transport.tracking-overview.widgets.news-updates.empty-state.title' | translate }}
          </h6>
        }

        @if (isError()) {
          <myarvato-error-message [summary]="errorMessage().title" [details]="errorMessage().description" />
        }
      </div>
    </div>
  </div>
</div>
